import React from 'react';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

import palette from '../styles/palette';
import { Text, View } from '../Base';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'green',
    borderRadius: '50%',
    height: '20px',
    width: '20px',
  },
  text: {
    fontSize: '12px',
    fontWeight: 500,
    color: palette.typography.white.solid,
  },
}));

const ChoiceDriverMarker = ({ containerClass }) => {
  const styles = useStyles();
  return (
    <View className={clsx(styles.container, containerClass)}>
      <Text className={styles.text}>C</Text>
    </View>
  );
};

export default ChoiceDriverMarker;
